export const designTabs = [
  { name: 'newDesign', displayName: 'New Design' },
  { name: 'myLibrary', displayName: 'My Library' },
];

export const MAX_DESIGN_FILE_SIZE = 25000000; // 25MB in bytes
